module.exports = __webpack_public_path__ + "img/p1.9fda77b0.png";